<template>
  <section class="container" id="player-preview">
    <div class="video-container">
      <ByteArkPlayerContainer :options="options" @ready="onReady" />
    </div>
    <div class="option-container">
      <code-block :code="code" language="js" showCopyBtn> </code-block>
    </div>
  </section>
</template>

<script>
import ByteArkPlayerContainer from "@byteark/byteark-player-vue";
import CodeBlock from "../atom/CodeBlock.vue";
import objectToString from "../../utils/jsonToString";
export default {
  name: "Preview",
  components: {
    ByteArkPlayerContainer,
    CodeBlock,
  },
  props: ["playerOptions"],
  data() {
    return {
      code: null,
      options: null,
    };
  },
  created() {
    this.options = this.playerOptions;
    this.code = objectToString(this.playerOptions);
  },
  methods: {
    onReady(newPlayerInstance) {
      newPlayerInstance.volume(this.options?.volume);
      window.player = newPlayerInstance;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@byteark/byteark-player-vue/dist/@byteark/byteark-player-vue.css";
@import "~@/assets/scss/container.scss";
.container {
  padding: $space/4;
  flex-wrap: nowrap;
  margin: 0 0 $space + 8px 0;

  .video-container {
    flex: 2;
    justify-self: center;
  }
  .option-container {
    /* flex: 1; */
    /* height: 100%; */
    width: 30%;
    text-align: center;
    h3 {
      margin: 0 0 1rem 0;
    }
  }
}
@media (max-width: $breakpoint-tablet) {
  .container {
    flex-direction: column;
    .option-container {
      width: 100%;
    }
  }
}
</style>
